/**
 * @ngdoc directives
 * @memberof mercury.modules.time
 * @name timerange
 */
angular.module('mercury.modules.time.roster')
.directive('timerange', ["$timeout", "$parse", function($timeout, $parse) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var start = $parse(attrs.timerangeBegin)(scope);
      var end = $parse(attrs.timerangeEnd)(scope);

      var seperator = ' - ';
      var displayFormat = 'HH:mm';

      var seperatorExists = function() {
        return element.val().indexOf($.trim(seperator)) !== -1;
      };

      var getCurrentSearchString = function() {
        var search = element.val();

        if (seperatorExists()) {
          search = search.substring(search.indexOf($.trim(seperator)) + 1);
        }

        return $.trim(search);
      };

      //Takes a time string and returns a moment object
      var convert = function(date) {
        var res = null;
        var dateParts = null;

        if (date.match(/^(1[012]|0?[1-9])(:[0-5]\d)?(\s?)[APap][mM]?$/)) {//12 hour time
          dateParts = date.split(/^(1[012]|0?[1-9])(:[0-5]\d)?(\s?)([APap][mM]?)/);
        } else if (date.match(/^([01][0-9]|2[0-3])(:[0-5]\d)?$/)) { //24 hour
          dateParts = date.split(/^([01][0-9]|2[0-3])(:[0-5]\d)?$/);
        }

        //If the regex matched and managed to split into sections, parse those sections into hours and minutes.
        if (dateParts !== null) {
          var hour = null;
          var minute = 0;
          angular.forEach(dateParts, function(part) {
            if (angular.isDefined(part) && $.trim(part) !== '') {
              if (hour === null) {
                hour = parseInt(part, 10);

                if (hour === 12) {
                  hour = 0;
                }
              } else if (part.indexOf(':') === 0) {
                minute = parseInt(part.substr(1), 10);
              } else if (part.toLowerCase() == 'pm' || part.toLowerCase() == 'p') {
                hour += 12;
              }
            }
          });
          var result = moment(start).mStartOf('day').hours(hour).minutes(minute);
          if (result.isBefore(moment(start).mStartOf('day'))) {
            result.add(24, 'hours');
          }
          res = result.format();
        }
        return res;
      };

      var convert24Alt = function(date) {
        var res = null;
        var dateParts = null;

        if (date.match(/^(1[012]|0?[1-9])(:[0-5]\d)?(\s?)[APap][mM]?$/)) {//12 hour time
          dateParts = date.split(/^(1[012]|0?[1-9])(:[0-5]\d)?(\s?)([APap][mM]?)/);
        } else if (date.match(/^([01][0-9]|2[0-3])(:[0-5]\d)?$/)) { //24 hour
          dateParts = date.split(/^([01][0-9]|2[0-3])(:[0-5]\d)?$/);
        }

        //If the regex matched and managed to split into sections, parse those sections into hours and minutes.
        if (dateParts !== null) {
          var hour = null;
          var minute = 0;
          angular.forEach(dateParts, function(part) {
            if (angular.isDefined(part) && $.trim(part) !== '') {
              if (hour === null) {
                hour = parseInt(part, 10);

                // if (hour === 12) {
                //   hour = 0;
                // }
              } else if (part.indexOf(':') === 0) {
                minute = parseInt(part.substr(1), 10);
              }
            }
          });
          var result = moment(start).mStartOf('day').hours(hour).minutes(minute);
          if (result.isBefore(moment(start).mStartOf('day'))) {
            result.add(24, 'hours');
          }
          res = result.format();
        }
        return res;
      };

      var parser = function(input) {
        var res = {start: null, end: null};

        if (seperatorExists()) {
          var parts = input.split(seperator);
          if (parts.length === 2) {
            // res.start = convert($.trim(parts[0]));
            // res.end = convert($.trim(parts[1]));
            res.start = convert24Alt($.trim(parts[0]));
            res.end = convert24Alt($.trim(parts[1]));
          }
        } else {
          res.start = convert($.trim(input));
        }
        return res;
      };

      var options = [];
      var date = moment(start).mStartOf('day');
      for (; options.length < 96; date.add(15, 'minutes')) {
        options.push({label: date.format(displayFormat), value: date.clone()});
      }

      if (start && end) {
        var startValue = moment(start);
        var endValue = moment(end);

        element.val(startValue.format(displayFormat) + seperator + endValue.format(displayFormat));

        if (moment(start).isAfter(end)) {
          $parse(attrs.timerangeError).assign(scope, 'Warning: This shift ends before it begins.');
          alert('Warning: This shift ends before it begins.');
        } else if (startValue.format('Z') !== endValue.format('Z')) {
          $parse(attrs.timerangeError).assign(scope, 'Note: Due to daylight savings, this shifts actual length is ' + endValue.diff(startValue, 'hours') + ' hours.');
        }
      }
      function blurUpdateElement(element) {
        var dates = parser(element.val());

        var startValue = null;
        var endValue = null;
        var errorMsg = null;

        var label = '';

        if (attrs.skipChecks) {
          startValue = moment(dates.start);
          endValue = moment(dates.end);
        } else {
          if (dates.start) {
            startValue = moment(dates.start);
            label += startValue.format(displayFormat);

            if (dates.end) {
              endValue = moment(dates.end);
              label += seperator + endValue.format(displayFormat);

              if (endValue.isBefore(startValue)) {
                errorMsg = 'Warning: This shift ends before it begins.';
              } else if (startValue.format('Z') !== endValue.format('Z')) {
                errorMsg = 'Note: Due to daylight savings, this shifts actual length is ' + endValue.diff(startValue, 'hours') + ' hours.';
              }
            }
          }
        }

        startValue = startValue.format();
        endValue = endValue.format();

        scope.$apply(function(scope) {
          $parse(attrs.timerangeBegin).assign(scope, startValue);
          $parse(attrs.timerangeEnd).assign(scope, endValue);
          $parse(attrs.timerangeError).assign(scope, errorMsg);
        });

        if (attrs.timerangeChange) {
          $timeout(function() {
            scope.$eval(attrs.timerangeChange);
          });
        }

        element.val(label);
      }

      $timeout(function() {
        $(element).autocomplete({
          autoFocus: true,
          delay: 0,
          source: function(req, res) {
            var search = getCurrentSearchString();
            var startTime;
            if (seperatorExists()) {
              startTime = convert($.trim(element.val().substring(0, element.val().indexOf(seperator))));
            }

            var opt = [];
            if (search !== '') {
              for (var index in options) {
                var isAfterStart = !startTime || options[index].value.isAfter(startTime);
                var patternMatches = options[index].label.indexOf(search) === 0;
                if (patternMatches && isAfterStart) {
                  opt.push(options[index]);
                }
              }
            }
            res(opt);
          },
          select: function(event, ui) {
            if (seperatorExists()) {
              var seperatorIndex = element.val().indexOf(seperator);
              element.val(element.val().substring(0, seperatorIndex) + seperator + ui.item.label);
            } else {
              element.val(ui.item.label + seperator);
            }
            return false;
          },
          focus: function() {
            return false;
          }
        }).focus(function() {
          $timeout(function() {
            element.select();
            if (element.hasClass('ui-autocomplete-input')) {
              element.autocomplete('search', element.val());
            }
          }, 10);
        }).blur(function() {
          blurUpdateElement(element);
        }).change(function() {
          blurUpdateElement(element);
        });
      }, 50);
    }
  };
}]);
